
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import DetailProduct from './DetailProduct';
import CategoriesScreen from './categories';
import ListProducts from './ListProducts';

function Index({dishs, setShowListProduct, setShowBuffet}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menus, setMenus] = useState([]);
    const [dataFood, setDataFood] = useState(false);
    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false); 
    const [grill, setGrill] = useState(false);
    const [ribeye, setRibeye] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showBebidasCalientes, setshowBebidasCalientes] = useState(false);
     const [showBebidasFrias, setshowBebidasFrias] = useState(false);
    const [showPolloBrasa, setshowPolloBrasa] = useState(false);
    const [dishs2, setdishs] = useState(false);
    const [showListProduct, setShowListProduct2] = useState(false);
       const [menusData, setMenusData] = useState([]);

    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenusData(data);
            setMenus(data);
        });
    }, []);
    

    useEffect(() => {
        menus.map((item) => {
            if (item.id === 257) {
                setDataFood(item.menus);
            }
        });
    }, [menus]);

    useEffect(() => {
        if (dataFood) {
            dataFood.map((item) => {
                if (item.id === 2811) {
                    setGrill(item);
                }
                if (item.id === 2385) {
                    setRibeye(item);
                }
            });
        }
    }, [dataFood]);
    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showFooter={false} showBack={true} setShowListProduct={setShowBuffet} goHome={setShowBuffet} goCategories={setshowCategories}>

                 <div style={{
                    background: 'white',
                    width: '92%',
                    margin: '0 auto',
                    display: 'flex',
                    padding: '10px 10px',
                    gap: 10,
                    justifyContent: 'space-between',
                    overflow: 'scroll',
                    position: 'relative',
                    zIndex: 100,
                    borderRadius: 14,
                    marginBottom: 20
                }}>
                    {menusData.map((item, key) => {
                            if (![443, 444, 445, 446, 448, 449, 450, 429, 430, 425, 424, 555, 565, 564, 566, 567, 516, 509, 513].includes(item.id)) {
                                return <div key={key} style={{  
                                    background: 'linear-gradient(90deg, #F93C36 0%, #92080B 100%)',

                                    display: 'flex',
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: '5px 15px',
                                     borderRadius: 14
                            }}
                                    onClick={() => { 
                                       
                                        
                                        if(item.id === 516) {
                                            setshowBebidasCalientes(true)
                                        }else if(item.id === 509) {
                                             setshowBebidasFrias(true)
                                         } else if(item.id === 513) {
                                             setshowPolloBrasa(true)
                                        } else {
                                             setShowListProduct2(true)
                                            setdishs(item)
                                            // setMenus(item.menus)
                                         }
                                    
                                }}
                                >
                                <p className='shor-text' style={{color: 'white', fontWeight: "900",fontSize: 15}}>{item.name}</p>

                            </div>
                            }
                            
                        })}
                </div>

                <div  style={{padding: '0 20px', height: 900,  overflow: 'scroll'}}>
                    <div
                       >
                        <img
                             onContextMenu={(e) => e.preventDefault()}
                            src={require('./assets/BEBIDAS-FRIAS.png')}
                            style={{
                                 pointerEvents: 'none',
                                width: '100%',
                                height: 740,
                                objectFit: 'contain',
                                borderRadius: 20,
                            }}
                        />
                    </div>

                </div>

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}

                {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowDetailProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}
                 {showListProduct && <ListProducts
                    dishs={dishs2}
                    setShowListProduct={setShowListProduct2}
                    goHome={setshowCategories}
                />}
            </LayoutContent>
        </div>
    );
}
export default Index;